"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BestfitRecalculatedEvent = void 0;
const enums_1 = require("../enums");
class BestfitRecalculatedEvent {
    constructor() {
        this.eventType = BestfitRecalculatedEvent.EventType;
        this.timestamp = new Date();
    }
}
exports.BestfitRecalculatedEvent = BestfitRecalculatedEvent;
BestfitRecalculatedEvent.EventType = enums_1.EventType.BESTFIT_RECALCULATED;
